import { Table as BaseTable, TableProps } from '@/components/table'
import { Query } from './table_query'
import { MaintenanceTypeTasksQuery } from './__generated__/table_query'
import { useQuery } from '@apollo/client'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { useState } from 'react'
import { MaintenanceTypeTaskFilters } from '@/types'
import { useTable } from '@/helpers/useTable'
import { Button } from '../base/button'
import { dedupe } from '@/helpers/dedupe'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Badge } from '../base/badge'
import { titleize } from '@/helpers/formatText'

interface Props extends TableProps {
  createable?: boolean
  filters?: MaintenanceTypeTaskFilters
}

export const Table = ({ pageSize = 20, filters = {}, createable = false, ...props }: Props) => {
  const { data, loading, error, refetch, fetchMore } = useQuery<MaintenanceTypeTasksQuery>(
    Query,
    { variables: { filters, first: pageSize } }
  )
  const {
    pageInfo,
    setOpenNew,
    setOpenDelete,
    openDelete
  } = useTable({ pageInfo: data?.maintenanceTypeTasks.pageInfo })
  const [maintenanceTypeTaskId, setMaintenanceTypeTaskId] = useState<string>()

  const deleteMaintenanceType = (id: string) => {
    setMaintenanceTypeTaskId(id)
    setOpenDelete(true)
  }

  if (error) { return <Error message={error.message} /> }
  if (loading || !data) { return <Loading /> }

  return (
    <>
      <BaseTable<MaintenanceTypeTaskFilters>
        {...props}
        actionButton={createable ? <Button color="green" onClick={() => setOpenNew(true)}>Add</Button> : undefined}
        headings={[{ name: 'Name' }, { name: 'Task type' }, { name: 'Required' }, { name: '' }]}
        initialFilters={filters}
        moreToFetch={pageInfo.current?.hasNextPage}
        refetch={refetch}
        fetchMore={() => fetchMore({
          variables: { after: pageInfo.current?.endCursor },
          updateQuery(previousData, { fetchMoreResult }) {
            if (Object.keys(previousData).length === 0) return fetchMoreResult
            fetchMoreResult.maintenanceTypeTasks.nodes = dedupe([
              ...previousData.maintenanceTypeTasks.nodes,
              ...fetchMoreResult.maintenanceTypeTasks.nodes
            ])
            return { ...fetchMoreResult }
          }
        })}
        filters={[
          {
            index: 0,
            setValue: (set, value) => set(f => ({ ...f, nameCont: value })),
            type: 'text',
            placeholder: 'Now, what did we call it?'
          },
        ]}
        rows={data.maintenanceTypeTasks.nodes.map(mt => (
          {
            id: mt.id,
            columns: [
              mt.name,
              titleize(mt.taskType || ''),
              mt.required ? <Badge color="green">Yes</Badge> : <Badge color="red">No</Badge>,
              <div className="text-right -mx-1">
                <Button color="red" onClick={() => deleteMaintenanceType(mt.id) }>Delete</Button>
              </div>
            ]
          }
        ))}
      />
      { maintenanceTypeTaskId && (<DeleteDialog
        id={maintenanceTypeTaskId}
        mutation={DeleteMutation}
        open={openDelete}
        refetchQueries={[Query]}
        setOpen={setOpenDelete}
        onSuccess={
          () => {
            setOpenDelete(false)
            setMaintenanceTypeTaskId(undefined)
          }
        }
      />) }
      {/* {  maintenanceTypeId && <EditDialog id={maintenanceTypeId} open={openShow} setOpen={setOpenShow} /> }

      <NewDialog open={openNew} setOpen={setOpenNew} /> */}
    </>
  )
}
